import * as React from 'react';
import { DateTime } from 'luxon';
import _toLower from 'lodash/toLower';
import _startCase from 'lodash/startCase';

import { Box, Button, Stack, Typography } from '@mui/material';

import FormPaper from '../FormPaper';
import SaveButton, { SaveButtonProps } from '../SaveButton';
import IncidentStatusChip from './IncidentStatusChip';

import { getColor } from '../../core/colors';
import { useAuthorizedFormData } from '../../core/context/AuthorizedFormDataContext';
import { Incident } from '../../core/api/clients';

interface IncidentFormBannerProps {
  incident: Incident;
  saveButtonProps: SaveButtonProps;
}

function IncidentFormBanner({ incident, saveButtonProps }: IncidentFormBannerProps): React.JSX.Element {
  const authorizedFormData = useAuthorizedFormData();

  const getReportedBy = () => {
    if (incident) {
      const { employeeName, employeeId, employeeTitle, employeeLocation } = incident;
      const formattedTitle = _startCase(_toLower(employeeTitle ?? ''));

      return `${employeeName} [${employeeId}], ${formattedTitle}, ${employeeLocation}`;
    }

    return null;
  };

  return (
    <FormPaper color={getColor(authorizedFormData.metadata?.color ?? 'grey')}>
      <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mx: 2, my: 1 }}>
        <Stack>
          <Box display="flex" alignItems="center">
            <Typography variant="h6">{`Incident: ${incident?.id}`}</Typography>
            <IncidentStatusChip
              status={incident?.status}
              sxChip={{ width: 60, height: 20, fontSize: 10 }}
              sxBox={{ ml: 1 }}
            />
          </Box>
          <Typography variant="caption">{`Reported By: ${getReportedBy()}`}</Typography>
          <Typography variant="caption">{`Created On: ${incident?.createdOn}`}</Typography>
        </Stack>
        <Stack direction="row" spacing={2}>
          <Button
            target="_blank"
            href={`/form/incident/${incident.id}/logs`}
          >
            Audit Logs
          </Button>
          <SaveButton {...saveButtonProps} />
        </Stack>
      </Box>
    </FormPaper>
  );
}

export default IncidentFormBanner;
